export enum IframeEvent {
    CLOSE_BLOCK = 'close_block',
    USER_ACTIVITY_TRACKED = 'user_activity_tracked',
    DISMISS_SUCCESSFUL_CART = 'dismiss_successful_cart',
    CHECKOUT_COMPLETED = 'checkout_completed',
    'ON_RESIZE' = 'on_resize'
}
